module.exports = __webpack_public_path__ + "img/bike_mechanic.5c3b86d4.png";